"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const events_1 = require("~/utils/events");
const assets_1 = require("~/assets");
const selectors_1 = require("~/store/selectors");
const utils_1 = require("~/utils/utils");
const projectSharing_1 = require("~/utils/projectSharing");
const CloseButton_1 = __importDefault(require("../common/controls/CloseButton"));
const NewProjectModal_1 = __importDefault(require("../ProjectManagement/NewProjectModal"));
const RestorationModal_1 = __importDefault(require("./RestorationModal/RestorationModal"));
const SignIn_1 = __importDefault(require("./AuthorizationForms/SignIn/SignIn"));
const SignUp_1 = __importDefault(require("./AuthorizationForms/SignUp/SignUp"));
const AuthorizationPanel_module_scss_1 = __importDefault(require("./AuthorizationPanel.module.scss"));
const AuthorizationForms_1 = require("./AuthorizationForms");
function AuthorizationPanel() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const isUserLogged = (0, react_redux_1.useSelector)(selectors_1.selectIsUserLogged);
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const bomItemsCount = (0, react_redux_1.useSelector)(selectors_1.selectBOMItemsCount);
    const dismissible = bomItemsCount < 3;
    const headline = location.state;
    const pathname = location.pathname.replace('/', '');
    const defaultMsg = 'Please sign in to enable full experience';
    (0, react_1.useEffect)(() => {
        if ((0, utils_1.getIsUserLogged)()) {
            const returnPath = (0, projectSharing_1.sharingReturnPath)();
            sessionStorage.removeItem('project-share-return');
            navigate(returnPath !== null && returnPath !== void 0 ? returnPath : '/', { replace: true });
            if (!returnPath && currentProject && !currentProject.user_id) {
                (0, events_1.showModal)(react_1.default.createElement(NewProjectModal_1.default, null));
            }
        }
    }, [isUserLogged, currentProject]);
    const renderAuthForm = (mode) => {
        var _a, _b;
        switch (mode) {
            case 'login':
                return react_1.default.createElement(SignIn_1.default, { headlineMsg: (_a = headline === null || headline === void 0 ? void 0 : headline.msg) !== null && _a !== void 0 ? _a : defaultMsg });
            case 'signup':
                return react_1.default.createElement(SignUp_1.default, null);
            case 'restore':
                return react_1.default.createElement(RestorationModal_1.default, null);
            case 'signout':
                return react_1.default.createElement(AuthorizationForms_1.SignOut, null);
            default:
                return react_1.default.createElement(SignIn_1.default, { headlineMsg: (_b = headline === null || headline === void 0 ? void 0 : headline.msg) !== null && _b !== void 0 ? _b : defaultMsg });
        }
    };
    return (react_1.default.createElement("div", { "data-testid": "auth-overlay", className: AuthorizationPanel_module_scss_1.default.overlay },
        react_1.default.createElement("div", { className: AuthorizationPanel_module_scss_1.default.window },
            react_1.default.createElement("div", { className: AuthorizationPanel_module_scss_1.default.widget },
                react_1.default.createElement("div", { className: AuthorizationPanel_module_scss_1.default.imgBlock },
                    react_1.default.createElement("img", { src: assets_1.svgFullLogo, alt: "" })),
                renderAuthForm(pathname),
                dismissible ? (react_1.default.createElement(CloseButton_1.default, { onCLickHandler: () => {
                        navigate('/');
                    } })) : (react_1.default.createElement("div", { style: { width: '30px' } }))))));
}
exports.default = AuthorizationPanel;
